export default __webpack_public_path__ + "static/media/mlrit-mun logo.48e26c5b.png";